export default __webpack_public_path__ + "static/media/instagram_4.71ac923b.png";